import React from "react"
import { IconType } from "react-icons"

interface IconButtonProps {
  Icon: IconType
  onClick: () => void
  ariaLabel: string
  className?: string
}

const IconButton: React.FC<IconButtonProps> = ({
  Icon,
  onClick,
  ariaLabel,
  className,
}) => {
  return (
    <button
      onClick={onClick}
      aria-label={ariaLabel}
      className={`p-1 rounded-full flex items-center justify-center transition-transform transform hover:scale-105 active:scale-95 focus:outline-none ${className}`}
    >
      <Icon className="text-gray-800 hover:text-blue-500" />
    </button>
  )
}

export default IconButton
